import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Button, Copy, H3 } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './InvalidBuild.styles';
import useSharedApps from '../../../utils/sitecoreContext/useSharedApps';
import { BUILD_AND_PRICE_URL } from '../../../utils/constants';
const Container = themeStyles.apply(Box, 'Container');
const Title = themeStyles.apply(H3, 'Title');
const ButtonWrapper = themeStyles.apply(Box, 'ButtonWrapper');
const CopySubText = themeStyles.apply(Copy, 'CopySubText');
const StartNewVehicleButton = themeStyles.apply(Button, 'StartNewVehicleButton');
const InvalidBuild = () => {
    const { t } = useTranslation();
    const invalidBuildHeader = t('Pages.Bap.noBuildModalHeading');
    const invalidBuildText = t('Pages.Bap.noBuildModalText');
    const invalidBuildCtaText = t('Pages.Bap.startOverButton');
    const bapUrl = useSharedApps(BUILD_AND_PRICE_URL);
    const navigateToBapStart = () => {
        window.location.href = bapUrl;
    };
    return (_jsxs(Container, { "data-testid": "cy-invalid-build", children: [_jsx(Title, { "data-testid": "cy-invalid-build-title", children: invalidBuildHeader }), _jsx(CopySubText, { "data-testid": "cy-invalid-build-details", children: invalidBuildText }), _jsx(ButtonWrapper, { "data-testid": "cy-invalid-build-cta", children: _jsx(StartNewVehicleButton, { styling: "primary", onClick: navigateToBapStart, children: invalidBuildCtaText }) })] }));
};
export default InvalidBuild;
